/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-complete': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<defs><path pid="0" d="M5.037 0c1.547 0 2.98.697 3.93 1.872a.5.5 0 0 1 .02.603l-.062.072-.635.61-.019.015-3.174 3.165a.5.5 0 0 1-.629.063L4.4 6.345l-1.792-1.71a.5.5 0 0 1 .62-.78l.07.056 1.44 1.374 3.137-3.13-.152-.142a4.04 4.04 0 0 0-2.453-1.006L5.037 1C2.807 1 1 2.792 1 5s1.806 4 4.037 4C6.996 9 8.66 7.608 9.008 5.723a.5.5 0 0 1 .984.18C9.558 8.263 7.479 10 5.037 10 2.256 10 0 7.762 0 5s2.256-5 5.037-5z" id="svgicon-icon-complete-a"/></defs><use _fill="#376F99" xlink:href="#svgicon-icon-complete-a" fill-rule="evenodd"/>'
  }
})
